module.exports = __webpack_public_path__ + "img/banner_3.f7e9681.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carousel/banner_3.jpg
// module id = t3C+
// module chunks = 0